import {getFormattedFullLocation} from '@wix/wix-events-commons-statics'
import classNames from 'classnames'
import React from 'react'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEventDateInformation} from '../../../../commons/hooks/dates'
import s from './full-date-location.scss'
import {FullDateLocationProps} from '.'

export const FullDateLocation: React.FC<FullDateLocationProps> = ({showDate, showLocation, event}) => {
  const {fullDate} = useEventDateInformation(event.id)
  const getContainerClasses = () => classNames({[s.noDate]: !showDate, [s.noLocation]: !showLocation})

  return (
    <div className={getContainerClasses()} data-hook={DH.fullDateLocation}>
      <div className={s.date} data-hook="date">
        {fullDate}
      </div>
      <div className={s.location} data-hook="location">
        {getFormattedFullLocation(event)}
      </div>
    </div>
  )
}
